var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { SetCheckedNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
var SelectedNodesPanelComponent = /** @class */ (function () {
    function SelectedNodesPanelComponent(store, graphService, changeDetector) {
        this.store = store;
        this.graphService = graphService;
        this.changeDetector = changeDetector;
        this.ngUnsubscribe = new Subject();
    }
    SelectedNodesPanelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkedNodes$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (nodes) {
            _this.count = _this.getLeaves(nodes).length;
            _this.changeDetector.markForCheck();
        });
    };
    SelectedNodesPanelComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SelectedNodesPanelComponent.prototype.handleClearClick = function () {
        this.store.dispatch(new SetCheckedNodes([]));
    };
    SelectedNodesPanelComponent.prototype.getLeaves = function (nodes) {
        if (!nodes) {
            return [];
        }
        return this.graphService.getAllLeafDescendants(this.store.selectSnapshot(EngineState.getViewGraph), nodes.map(function (node) { return node.id; }));
    };
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], SelectedNodesPanelComponent.prototype, "checkedNodes$", void 0);
    return SelectedNodesPanelComponent;
}());
export { SelectedNodesPanelComponent };
